<template>{{ name }}</template>
<script setup>
import supabase from "@/supabase/config";
import { onMounted, defineProps, ref } from "vue";
const props = defineProps(["team_id"]);
const name = ref("");
onMounted(() => {
  fetchName();
});
const fetchName = async () => {
  let { data: players, error } = await supabase
    .from("teams")
    .select("name")
    .eq("id", props.team_id);
  name.value = players[0].name;
};
</script>
